import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', // serviço global
})
export class AuthStateService {
  private emailSubject = new BehaviorSubject<string | null>(null);
  private passwordSubject = new BehaviorSubject<string | null>(null);

  email$ = this.emailSubject.asObservable();
  password$ = this.passwordSubject.asObservable();

  setCredentials(email: string, password: string) {
    this.emailSubject.next(email);
    this.passwordSubject.next(password);
  }

  clearCredentials() {
    this.emailSubject.next(null);
    this.passwordSubject.next(null);
  }

  getEmail(): string | null {
    return this.emailSubject.value;
  }

  getPassword(): string | null {
    return this.passwordSubject.value;
  }
}
